import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from './../../../environments/environment';
import { BussinessDocumentsTypeModel } from './../../models/management/bussiness-documents-type.models';

@Injectable({
  providedIn: 'root'
})
export class BussinessDocumentsTypeService {

  constructor(private _httpClient: HttpClient) { }

  createBussinessDocumentsType(bussinessDocumentsTypeContract: BussinessDocumentsTypeModel): Observable<BussinessDocumentsTypeModel> {
    return this._httpClient.post<BussinessDocumentsTypeModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsType.CreateBussinessDocumentsType}`,
      bussinessDocumentsTypeContract);
  }

  deleteBussinessDocumentsType(bussinessDocumentsTypeId: number): Observable<BussinessDocumentsTypeModel> {
    return this._httpClient.delete<BussinessDocumentsTypeModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsType.DeleteBussinessDocumentsType}/${bussinessDocumentsTypeId}`);
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsType.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getAllBussinessDocumentsClasssForSelect(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsType.GetAllBussinessDocumentsClasssForSelectAsync}`);
  }

  getAllBussinessDocumentsDianTypesForSelect(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsType.GetAllBussinessDocumentsDianTypesForSelectAsync}`);
  }

  getBussinessDocumentsType(bussinessDocumentsTypeId: number): Observable<any> {
    const params = new HttpParams().set('bussinessDocumentsTypeId', bussinessDocumentsTypeId);
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsType.GetBussinessDocumentsTypeAsync}`,
      { params: params }
    );
  }

  getAllBussinessDocumentsTypesWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsType.GetAllBussinessDocumentsTypesWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getBussinessDocumentsTypeById(bussinessDocumentsTypeId: number): Observable<BussinessDocumentsTypeModel> {
    return this._httpClient.get<BussinessDocumentsTypeModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsType.GetBussinessDocumentsTypeById}/${bussinessDocumentsTypeId}`);
  }

  getBussinessDocumentsTypeByKeys(bussinessDocumentsClassId: number, branchId: number, enterpriseId: number, code: number): Observable<BussinessDocumentsTypeModel> {
    const params = new HttpParams().set('bussinessDocumentsClassId', bussinessDocumentsClassId).set('branchId', branchId).set('enterpriseId', enterpriseId).set('code', code);
    return this._httpClient.get<BussinessDocumentsTypeModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsType.GetBussinessDocumentsTypeByKeys}`,
      { params: params });
  }

  getBussinessDocumentsTypesByClassByBranchByEnterprise(bussinessDocumentsClassId: number, branchId: number, enterpriseId: number): Observable<Array<BussinessDocumentsTypeModel>> {
    return this._httpClient.get<Array<BussinessDocumentsTypeModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsType.GetBussinessDocumentsTypesByClassByBranchByEnterprise}/${bussinessDocumentsClassId}/${branchId}/${enterpriseId}`)
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsType.GetColumnsForGeneralConsultationAsync}`);
  }

  getColumnsForSelection(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsType.GetColumnsForSelectionAsync}`);
  }

  getFirstBussinessDocumentsType(bussinessDocumentsClassId: number, enterpriseId: number): Observable<BussinessDocumentsTypeModel> {
    return this._httpClient.get<BussinessDocumentsTypeModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsType.GetFirstBussinessDocumentsType}/${bussinessDocumentsClassId}/${enterpriseId}`)
  }

  getFirstBussinessDocumentsTypeByKeys(bussinessDocumentsClassId: number, branchId: number, enterpriseId: number): Observable<BussinessDocumentsTypeModel> {
    const params = new HttpParams().set('bussinessDocumentsClassId', bussinessDocumentsClassId).set('branchId', branchId).set('enterpriseId', enterpriseId);
    return this._httpClient.get<BussinessDocumentsTypeModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsType.GetFirstBussinessDocumentsTypeByKeysAsync}`,
      { params: params }
    );
  }

  getLastBussinessDocumentsTypeByKeys(bussinessDocumentsClassId: number, branchId: number, enterpriseId: number): Observable<BussinessDocumentsTypeModel> {
    const params = new HttpParams().set('bussinessDocumentsClassId', bussinessDocumentsClassId).set('branchId', branchId).set('enterpriseId', enterpriseId);
    return this._httpClient.get<BussinessDocumentsTypeModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsType.GetLastBussinessDocumentsTypeByKeysAsync}`,
      { params: params }
    );
  }

  getNextBussinessDocumentsTypeByKeys(bussinessDocumentsClassId: number, branchId: number, enterpriseId: number, code: number): Observable<BussinessDocumentsTypeModel> {
    const params = new HttpParams().set('bussinessDocumentsClassId', bussinessDocumentsClassId).set('branchId', branchId).set('enterpriseId', enterpriseId).set('code', code);
    return this._httpClient.get<BussinessDocumentsTypeModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsType.GetNextBussinessDocumentsTypeByKeysAsync}`,
      { params: params }
    );
  }

  getPreviusBussinessDocumentsTypeByKeys(bussinessDocumentsClassId: number, branchId: number, enterpriseId: number, code: number): Observable<BussinessDocumentsTypeModel> {
    const params = new HttpParams().set('bussinessDocumentsClassId', bussinessDocumentsClassId).set('branchId', branchId).set('enterpriseId', enterpriseId).set('code', code);
    return this._httpClient.get<BussinessDocumentsTypeModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsType.GetPreviusBussinessDocumentsTypeByKeysAsync}`,
      { params: params }
    );
  }

  setActiveBussinessDocumentsType(bussinessDocumentsTypeId: number): Observable<BussinessDocumentsTypeModel> {
    return this._httpClient.put<BussinessDocumentsTypeModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsType.SetActiveBussinessDocumentsType}/${bussinessDocumentsTypeId}`,
      null);
  }

  updateBussinessDocumentsType(bussinessDocumentsTypeContract: BussinessDocumentsTypeModel): Observable<BussinessDocumentsTypeModel> {
    return this._httpClient.put<BussinessDocumentsTypeModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsType.UpdateBussinessDocumentsType}`,
      bussinessDocumentsTypeContract);
  }

  getBussinessDocumentsTypesForSelection(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsType.GetBussinessDocumentsTypesForSelectionAsync}`,
      filters, { params: params }
    );
  }
}
